export const QUESTIONS_AMOUNT = 15;
